export default "__VITE_ASSET__Gin1AGvN__"